import clsx from 'clsx';
import { nanoid } from 'nanoid';
import { FaPlusCircle } from 'react-icons/fa';
import shallow from 'zustand/shallow';
import useRequestFormStore from '../store';

interface AddEpisodeButtonProps {
	diseaseId: string;
	isInAutosave: boolean;
	hasUnsavedEpisodes: boolean;
}

const AddEpisodeButton = ({ diseaseId, hasUnsavedEpisodes }: AddEpisodeButtonProps) => {
  const [updateField, episodes] = useRequestFormStore(
    (store) => [store.updateField, store.diseases?.[diseaseId]?.episodes],
    shallow
  );

  const handleAddEpisode = () => {
    if (hasUnsavedEpisodes) return;

    const id = nanoid();
    const newEpisodeList = Object.assign({}, episodes);
    newEpisodeList[id] = {
      isTargetEpisode: false,
      diagnosisStatus: null,
      isSaved: false,
      areasOfMetastasis: [],
      areasOfRecurrence: []
    };

    if (diseaseId) {
      newEpisodeList[id].diseaseId = diseaseId;
    }

    updateField(`diseases.${diseaseId}.episodes`, newEpisodeList);
  };

  return (
    <button
      type="button"
      className={clsx(
        'relative flex items-center flex-wrap justify-center w-full p-8 transition-colors duration-200 bg-gray-100 border-2 border-gray-300 border-dashed rounded-md ',
        !hasUnsavedEpisodes && 'hover:bg-white hover:border-gray-400 text-gray-600',
        hasUnsavedEpisodes && 'text-gray-400 cursor-not-allowed'
      )}
      onClick={handleAddEpisode}
    >
      <span className={'flex flex-wrap items-center justify-center w-full'}>
        <FaPlusCircle className="mr-2" /> Add History...
        <p className="w-full mt-2 text-sm">
					History includes details on the initial diagnosis, recurrence, and progression.
        </p>
      </span>
    </button>
  );
};

export { AddEpisodeButton as default };
